// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ButtonGroup_buttonWrapper__qBj-C","previousButton":"ButtonGroup_previousButton__poEQ9","nextButton":"ButtonGroup_nextButton__9neRw"};